module.exports = __webpack_public_path__ + "img/carla.00409829.png";